export const MIN_TRACK_WIDTH = 40;

export const MAX_TRACK_WIDTH = 2000;

export const COLLAPSED_LEGEND_HEIGHT = 17;

export const BASE_LEGEND_HEIGHT = 17 * 2;
